import GuidedClaimsEditor from './GuidedClaimsEditor.vue'
import StructuredClaimsEditor from './StructuredClaimsEditor.vue'

const ClaimEditorMode = Object.freeze({
    GUIDED: 'guided',
    STRUCTURED: 'structured',
})

const CLAIM_EDITORS = Object.freeze({
    [ClaimEditorMode.GUIDED]: GuidedClaimsEditor,
    [ClaimEditorMode.STRUCTURED]: StructuredClaimsEditor,
})

const resolveClaimEditor = mode => CLAIM_EDITORS[mode] || StructuredClaimsEditor

export {
    CLAIM_EDITORS,
    ClaimEditorMode,
    resolveClaimEditor,
}
